import React, { useEffect, useRef, useState } from 'react';
import { useTheme } from '../themes/ThemeContext';

export default function ThemePicker() {
  const { themeId, themes, setThemeId } = useTheme();
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  const active = themes.find((t) => t.id === themeId) ?? themes[0];

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  return (
    <div ref={rootRef} className={`animus-theme-picker${open ? ' is-open' : ''}`}>
      <button
        type="button"
        className="animus-theme-picker__toggle"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-label={`Choose colour theme — ${active.label}`}
        title={active.label}
      >
        <span className="animus-theme-picker__label">CHROMA {'//'}</span>
        <span
          className="animus-theme-swatch animus-theme-swatch--current"
          style={{ '--swatch-color': active.swatch }}
          aria-hidden="true"
        />
        <span className="animus-theme-picker__name">{active.label}</span>
      </button>
      {open && (
        <div className="animus-theme-picker__panel" role="listbox" aria-label="Theme colours">
          {themes.map((theme) => {
            const isActive = theme.id === themeId;
            return (
              <button
                key={theme.id}
                type="button"
                role="option"
                aria-selected={isActive}
                className={`animus-theme-picker__option${isActive ? ' is-active' : ''}`}
                onClick={() => {
                  setThemeId(theme.id);
                  setOpen(false);
                }}
                title={theme.label}
              >
                <span
                  className="animus-theme-swatch"
                  style={{ '--swatch-color': theme.swatch }}
                  aria-hidden="true"
                />
                <span className="animus-theme-picker__option-label">{theme.label}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
